// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const MoneyTimeIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "MoneyTime/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.167 11.667A3.332 3.332 0 0 0 .833 15a3.332 3.332 0 0 0 3.334 3.333A3.332 3.332 0 0 0 7.5 15a3.332 3.332 0 0 0-3.333-3.333ZM5 14.733c0 .509-.275.992-.708 1.25l-.634.384a.628.628 0 0 1-.858-.208.626.626 0 0 1 .217-.859l.633-.383a.214.214 0 0 0 .1-.175v-.775c0-.35.283-.634.625-.634a.63.63 0 0 1 .625.625v.775Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.167 3.333H5.833c-2.5 0-4.166 1.25-4.166 4.167v2.967c0 .308.316.5.591.375a4.614 4.614 0 0 1 2.75-.342c2.192.392 3.8 2.425 3.742 4.65a4.23 4.23 0 0 1-.15 1.025c-.067.258.142.5.408.5h5.159c2.5 0 4.166-1.25 4.166-4.167V7.5c0-2.917-1.666-4.167-4.166-4.167ZM10 12.083a2.084 2.084 0 1 1 .001-4.168A2.084 2.084 0 0 1 10 12.083Zm6.042-.416a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V8.333a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v3.334Z"
}));
export default MoneyTimeIcon;